import { render, staticRenderFns } from "./index.vue?vue&type=template&id=437d1d1d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437d1d1d')) {
      api.createRecord('437d1d1d', component.options)
    } else {
      api.reload('437d1d1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=437d1d1d&", function () {
      api.rerender('437d1d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/footer/index.vue"
export default component.exports